import apiService from "@/utils/request";
export const industryServe = {
  getIndustry() {
    return apiService.get("/policy/v2/industry/");
  },
};
